import cache from './portal-cache'
import file from './file'
import subcontent from './subcontent'
import role from './role' //권한추가
import auth from './auth'
import usercard from './usercard'

export default { cache, file, subcontent, role, auth, usercard } //role 추가
